import { useTranslation } from 'react-i18next'
import type { useAiChatDecisionForm } from './use-ai-chat-decision-form'
import { Button } from '@/shared/ui/button'

type Props = {
  form: ReturnType<typeof useAiChatDecisionForm>
  canAnswer: boolean
  canCancel: boolean
}

export function AiChatDecisionActions({ form, canAnswer, canCancel }: Props) {
  const { t } = useTranslation('aiChat')
  const { step, isLast, back } = form.steps

  let primaryLabel = 'decisionNext'
  if (isLast) primaryLabel = form.busy ? 'decisionSubmitting' : 'decisionSubmit'

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <Button
        type="button"
        size="sm"
        variant="ghost"
        disabled={form.locked || !canCancel}
        onClick={() => {
          void form.perform(true)
        }}
      >
        {t('decisionCancel')}
      </Button>
      <div className="flex gap-2">
        {step > 0 ? (
          <Button
            type="button"
            size="sm"
            variant="outline"
            disabled={form.locked}
            onClick={back}
          >
            {t('decisionBack')}
          </Button>
        ) : null}
        <Button
          type="submit"
          size="sm"
          disabled={form.locked || (isLast && !canAnswer)}
        >
          {t(primaryLabel)}
        </Button>
      </div>
    </div>
  )
}
